var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/custom-instance.ts
var tester = (() => {
  let baseUrl = "";
  let headers = () => Promise.resolve({});
  const request = async (config) => {
    const { url: pathname, params, method: _method, data } = config;
    const method = _method == null ? void 0 : _method.toUpperCase();
    const url = new URL(`${baseUrl}${pathname}`);
    for (const [key, value] of Object.entries(params != null ? params : {})) {
      url.searchParams.set(key, value);
    }
    const response = await fetch(url.toString(), {
      method,
      body: method === "GET" ? void 0 : JSON.stringify(data != null ? data : {}),
      headers: __spreadProps(__spreadValues({}, await headers()), {
        "Content-Type": "application/json;charset=utf-8"
      })
    });
    const json = await response.json();
    if (response.ok) {
      handleDates(json);
      return json;
    } else {
      const { message, statusCode, error } = json;
      const err = new Error(Array.isArray(message) ? message.join("\n") : message);
      err.name = `${statusCode} ${error}`;
      throw err;
    }
  };
  const setBaseUrl = (newBaseUrl) => {
    baseUrl = newBaseUrl;
  };
  const setHeaders = (newSetHeaders) => {
    headers = newSetHeaders;
  };
  return {
    request,
    setBaseUrl,
    setHeaders
  };
})();
var customInstance = tester.request;
var CUSTOM_FETCHER = tester;
var isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[-+]\d{2}:?\d{2}|Z)?$/;
function isIsoDateString(value) {
  return value && typeof value === "string" && isoDateFormat.test(value);
}
function handleDates(body) {
  if (body === null || body === void 0 || typeof body !== "object")
    return body;
  for (const key of Object.keys(body)) {
    const value = body[key];
    if (isIsoDateString(value)) {
      body[key] = new Date(value);
    } else if (typeof value === "object") {
      handleDates(value);
    }
  }
}

// src/generated/models/updateUserResponseDtoType.ts
var UpdateUserResponseDtoType = {
  teacher: "teacher",
  student: "student",
  developer: "developer"
};

// src/generated/models/updateUserResponseDtoStatus.ts
var UpdateUserResponseDtoStatus = {
  created: "created",
  pending: "pending",
  unverified: "unverified",
  active: "active",
  deactivated: "deactivated"
};

// src/generated/models/createUserResponseDtoStatus.ts
var CreateUserResponseDtoStatus = {
  created: "created",
  pending: "pending",
  unverified: "unverified",
  active: "active",
  deactivated: "deactivated"
};

// src/generated/models/createClassroomRequestDtoGrade.ts
var CreateClassroomRequestDtoGrade = {
  NUMBER_1: "1",
  NUMBER_2: "2",
  NUMBER_3: "3",
  NUMBER_4: "4",
  NUMBER_5: "5",
  NUMBER_6: "6",
  NUMBER_7: "7",
  NUMBER_8: "8",
  NUMBER_9: "9",
  NUMBER_10: "10",
  NUMBER_11: "11",
  NUMBER_12: "12",
  NUMBER_13: "13",
  pre_kindergarten: "pre_kindergarten",
  transitional_kindergarten: "transitional_kindergarten",
  kindergarten: "kindergarten",
  infant_toddler: "infant_toddler",
  preschool: "preschool",
  post_graduate: "post_graduate",
  ungraded: "ungraded",
  other: "other"
};

// src/generated/models/updateClassroomRequestDtoGrade.ts
var UpdateClassroomRequestDtoGrade = {
  NUMBER_1: "1",
  NUMBER_2: "2",
  NUMBER_3: "3",
  NUMBER_4: "4",
  NUMBER_5: "5",
  NUMBER_6: "6",
  NUMBER_7: "7",
  NUMBER_8: "8",
  NUMBER_9: "9",
  NUMBER_10: "10",
  NUMBER_11: "11",
  NUMBER_12: "12",
  NUMBER_13: "13",
  pre_kindergarten: "pre_kindergarten",
  transitional_kindergarten: "transitional_kindergarten",
  kindergarten: "kindergarten",
  infant_toddler: "infant_toddler",
  preschool: "preschool",
  post_graduate: "post_graduate",
  ungraded: "ungraded",
  other: "other"
};

// src/generated/models/updateClassroomResponseDtoGrade.ts
var UpdateClassroomResponseDtoGrade = {
  NUMBER_1: "1",
  NUMBER_2: "2",
  NUMBER_3: "3",
  NUMBER_4: "4",
  NUMBER_5: "5",
  NUMBER_6: "6",
  NUMBER_7: "7",
  NUMBER_8: "8",
  NUMBER_9: "9",
  NUMBER_10: "10",
  NUMBER_11: "11",
  NUMBER_12: "12",
  NUMBER_13: "13",
  pre_kindergarten: "pre_kindergarten",
  transitional_kindergarten: "transitional_kindergarten",
  kindergarten: "kindergarten",
  infant_toddler: "infant_toddler",
  preschool: "preschool",
  post_graduate: "post_graduate",
  ungraded: "ungraded",
  other: "other"
};

// src/generated/models/createStudentForClassroomResponseDtoStatus.ts
var CreateStudentForClassroomResponseDtoStatus = {
  created: "created",
  pending: "pending",
  unverified: "unverified",
  active: "active",
  deactivated: "deactivated"
};

// src/generated/models/createStudentForClassroomResponseDtoType.ts
var CreateStudentForClassroomResponseDtoType = {
  teacher: "teacher",
  student: "student",
  developer: "developer"
};

// src/generated/models/studentWithGradeDtoType.ts
var StudentWithGradeDtoType = {
  teacher: "teacher",
  student: "student",
  developer: "developer"
};

// src/generated/models/studentWithGradeDtoStatus.ts
var StudentWithGradeDtoStatus = {
  created: "created",
  pending: "pending",
  unverified: "unverified",
  active: "active",
  deactivated: "deactivated"
};

// src/generated/models/studentWithGradeDtoPerformanceTrend.ts
var StudentWithGradeDtoPerformanceTrend = {
  not_enough_data: "not_enough_data",
  trending_upwards: "trending_upwards",
  trending_within_threshold: "trending_within_threshold",
  trending_downwards: "trending_downwards"
};

// src/generated/models/createUserResponseDtoType.ts
var CreateUserResponseDtoType = {
  teacher: "teacher",
  student: "student",
  developer: "developer"
};

// src/generated/models/classroomStudentPerformanceResponseDtoPerformance.ts
var ClassroomStudentPerformanceResponseDtoPerformance = {
  not_enough_data: "not_enough_data",
  trending_upwards: "trending_upwards",
  trending_within_threshold: "trending_within_threshold",
  trending_downwards: "trending_downwards"
};

// src/generated/models/submissionResponseDtoStatus.ts
var SubmissionResponseDtoStatus = {
  active: "active",
  completed: "completed"
};

// src/generated/models/createAssignmentResponseDtoStatus.ts
var CreateAssignmentResponseDtoStatus = {
  active: "active",
  grading_pending: "grading_pending",
  graded: "graded"
};

// src/generated/models/createAssignmentRequestDtoGrade.ts
var CreateAssignmentRequestDtoGrade = {
  NUMBER_3: "3",
  NUMBER_4: "4",
  NUMBER_5: "5",
  NUMBER_6: "6",
  NUMBER_7: "7",
  NUMBER_8: "8"
};

// src/generated/models/assignmentResponseDtoStatus.ts
var AssignmentResponseDtoStatus = {
  active: "active",
  grading_pending: "grading_pending",
  graded: "graded"
};

// src/generated/models/studentPerformanceDtoPerformanceOneOfStatus.ts
var StudentPerformanceDtoPerformanceOneOfStatus = {
  completed: "completed"
};

// src/generated/models/studentPerformanceDtoPerformanceOneOfThreeStatus.ts
var StudentPerformanceDtoPerformanceOneOfThreeStatus = {
  in_progress: "in_progress"
};

// src/generated/models/suggestionResponseDtoCategory.ts
var SuggestionResponseDtoCategory = {
  default: "default",
  late_submission: "late_submission",
  low_performance: "low_performance"
};

// src/generated/models/userResponseDtoStatus.ts
var UserResponseDtoStatus = {
  created: "created",
  pending: "pending",
  unverified: "unverified",
  active: "active",
  deactivated: "deactivated"
};

// src/generated/models/userResponseDtoType.ts
var UserResponseDtoType = {
  teacher: "teacher",
  student: "student",
  developer: "developer"
};

// src/generated/models/createTagRequestDtoType.ts
var CreateTagRequestDtoType = {
  unspecified: "unspecified",
  item: "item"
};

// src/generated/models/completeSubmissionResponseDtoTrend.ts
var CompleteSubmissionResponseDtoTrend = {
  not_enough_data: "not_enough_data",
  trending_upwards: "trending_upwards",
  trending_within_threshold: "trending_within_threshold",
  trending_downwards: "trending_downwards"
};

// src/generated/models/submissionResponseDtoTrend.ts
var SubmissionResponseDtoTrend = {
  not_enough_data: "not_enough_data",
  trending_upwards: "trending_upwards",
  trending_within_threshold: "trending_within_threshold",
  trending_downwards: "trending_downwards"
};

// src/generated/models/updateAssignmentResponseDtoStatus.ts
var UpdateAssignmentResponseDtoStatus = {
  active: "active",
  grading_pending: "grading_pending",
  graded: "graded"
};

// src/generated/models/createItemRequestDtoStatus.ts
var CreateItemRequestDtoStatus = {
  unspecified: "unspecified",
  published: "published",
  editing: "editing",
  deleted: "deleted"
};

// src/generated/models/updateItemRequestDtoStatus.ts
var UpdateItemRequestDtoStatus = {
  unspecified: "unspecified",
  published: "published",
  editing: "editing",
  deleted: "deleted"
};

// src/generated/models/backofficeCreateClassroomRequestDtoGrade.ts
var BackofficeCreateClassroomRequestDtoGrade = {
  NUMBER_1: "1",
  NUMBER_2: "2",
  NUMBER_3: "3",
  NUMBER_4: "4",
  NUMBER_5: "5",
  NUMBER_6: "6",
  NUMBER_7: "7",
  NUMBER_8: "8",
  NUMBER_9: "9",
  NUMBER_10: "10",
  NUMBER_11: "11",
  NUMBER_12: "12",
  NUMBER_13: "13",
  pre_kindergarten: "pre_kindergarten",
  transitional_kindergarten: "transitional_kindergarten",
  kindergarten: "kindergarten",
  infant_toddler: "infant_toddler",
  preschool: "preschool",
  post_graduate: "post_graduate",
  ungraded: "ungraded",
  other: "other"
};

// src/generated/models/completeSubmissionResponseDtoStatus.ts
var CompleteSubmissionResponseDtoStatus = {
  active: "active",
  completed: "completed"
};

// src/generated/models/createClassroomResponseDtoGrade.ts
var CreateClassroomResponseDtoGrade = {
  NUMBER_1: "1",
  NUMBER_2: "2",
  NUMBER_3: "3",
  NUMBER_4: "4",
  NUMBER_5: "5",
  NUMBER_6: "6",
  NUMBER_7: "7",
  NUMBER_8: "8",
  NUMBER_9: "9",
  NUMBER_10: "10",
  NUMBER_11: "11",
  NUMBER_12: "12",
  NUMBER_13: "13",
  pre_kindergarten: "pre_kindergarten",
  transitional_kindergarten: "transitional_kindergarten",
  kindergarten: "kindergarten",
  infant_toddler: "infant_toddler",
  preschool: "preschool",
  post_graduate: "post_graduate",
  ungraded: "ungraded",
  other: "other"
};

// src/generated/models/itemResponseDtoStatus.ts
var ItemResponseDtoStatus = {
  unspecified: "unspecified",
  published: "published",
  editing: "editing",
  deleted: "deleted"
};

// src/generated/models/tagResponseDtoType.ts
var TagResponseDtoType = {
  unspecified: "unspecified",
  item: "item"
};

// src/generated/models/classroomResponseDtoGrade.ts
var ClassroomResponseDtoGrade = {
  NUMBER_1: "1",
  NUMBER_2: "2",
  NUMBER_3: "3",
  NUMBER_4: "4",
  NUMBER_5: "5",
  NUMBER_6: "6",
  NUMBER_7: "7",
  NUMBER_8: "8",
  NUMBER_9: "9",
  NUMBER_10: "10",
  NUMBER_11: "11",
  NUMBER_12: "12",
  NUMBER_13: "13",
  pre_kindergarten: "pre_kindergarten",
  transitional_kindergarten: "transitional_kindergarten",
  kindergarten: "kindergarten",
  infant_toddler: "infant_toddler",
  preschool: "preschool",
  post_graduate: "post_graduate",
  ungraded: "ungraded",
  other: "other"
};

// src/generated/endpoints.ts
import {
  useQuery,
  useMutation
} from "react-query";
var signUp = (createTeacherRequestDto) => {
  return customInstance({
    url: `/users`,
    method: "post",
    data: createTeacherRequestDto
  });
};
var useSignUp = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { data } = props || {};
    return signUp(data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var findSelf = () => {
  return customInstance({ url: `/users/me`, method: "get" });
};
var getFindSelfQueryKey = () => [`/users/me`];
var useFindSelf = (options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getFindSelfQueryKey();
  const queryFn = () => findSelf();
  const query = useQuery(queryKey, queryFn, queryOptions);
  return __spreadValues({
    queryKey
  }, query);
};
var updateUserPassword = (updatePasswordRequestDto) => {
  return customInstance({
    url: `/users/me/password`,
    method: "put",
    data: updatePasswordRequestDto
  });
};
var useUpdateUserPassword = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { data } = props || {};
    return updateUserPassword(data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var findUser = (id) => {
  return customInstance({
    url: `/users/${id}`,
    method: "get"
  });
};
var getFindUserQueryKey = (id) => [`/users/${id}`];
var useFindUser = (id, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getFindUserQueryKey(id);
  const queryFn = () => findUser(id);
  const query = useQuery(queryKey, queryFn, __spreadValues({ enabled: !!id }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var updateUser = (id, updateUserRequestDto) => {
  return customInstance({
    url: `/users/${id}`,
    method: "patch",
    data: updateUserRequestDto
  });
};
var useUpdateUser = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { id, data } = props || {};
    return updateUser(id, data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var acceptInvitation = (acceptInvitationRequestDto, params) => {
  return customInstance({
    url: `/users/invitation/accept`,
    method: "post",
    data: acceptInvitationRequestDto,
    params
  });
};
var useAcceptInvitation = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { data, params } = props || {};
    return acceptInvitation(data, params);
  };
  return useMutation(mutationFn, mutationOptions);
};
var validateInvitationToken = (params) => {
  return customInstance({
    url: `/users/invitation/validate`,
    method: "post",
    params
  });
};
var useValidateInvitationToken = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { params } = props || {};
    return validateInvitationToken(params);
  };
  return useMutation(mutationFn, mutationOptions);
};
var acceptVerificationToken = (params) => {
  return customInstance({
    url: `/users/email-verification/accept`,
    method: "post",
    params
  });
};
var useAcceptVerificationToken = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { params } = props || {};
    return acceptVerificationToken(params);
  };
  return useMutation(mutationFn, mutationOptions);
};
var sendVerificationEmail = (params) => {
  return customInstance({
    url: `/users/email-verification/send`,
    method: "post",
    params
  });
};
var useSendVerificationEmail = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { params } = props || {};
    return sendVerificationEmail(params);
  };
  return useMutation(mutationFn, mutationOptions);
};
var login = (loginRequestDto) => {
  return customInstance({
    url: `/auth/login`,
    method: "post",
    data: loginRequestDto
  });
};
var useLogin = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { data } = props || {};
    return login(data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var refreshToken = (refreshTokenRequestDto) => {
  return customInstance({
    url: `/auth/refresh-token`,
    method: "post",
    data: refreshTokenRequestDto
  });
};
var useRefreshToken = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { data } = props || {};
    return refreshToken(data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var resetPassword = (resetPasswordRequestDto) => {
  return customInstance({
    url: `/auth/password/reset`,
    method: "post",
    data: resetPasswordRequestDto
  });
};
var useResetPassword = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { data } = props || {};
    return resetPassword(data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var forgotPassword = (forgotPasswordRequestDto) => {
  return customInstance({
    url: `/auth/password/forgot`,
    method: "post",
    data: forgotPasswordRequestDto
  });
};
var useForgotPassword = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { data } = props || {};
    return forgotPassword(data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var getClassroom = (id) => {
  return customInstance({
    url: `/classrooms/${id}`,
    method: "get"
  });
};
var getGetClassroomQueryKey = (id) => [`/classrooms/${id}`];
var useGetClassroom = (id, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetClassroomQueryKey(id);
  const queryFn = () => getClassroom(id);
  const query = useQuery(queryKey, queryFn, __spreadValues({ enabled: !!id }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var updateClassroom = (id, updateClassroomRequestDto) => {
  return customInstance({
    url: `/classrooms/${id}`,
    method: "patch",
    data: updateClassroomRequestDto
  });
};
var useUpdateClassroom = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { id, data } = props || {};
    return updateClassroom(id, data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var deactivateClassroom = (id) => {
  return customInstance({
    url: `/classrooms/${id}`,
    method: "delete"
  });
};
var useDeactivateClassroom = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { id } = props || {};
    return deactivateClassroom(id);
  };
  return useMutation(mutationFn, mutationOptions);
};
var listClassrooms = (params) => {
  return customInstance({
    url: `/classrooms`,
    method: "get",
    params
  });
};
var getListClassroomsQueryKey = (params) => [
  `/classrooms`,
  ...params ? [params] : []
];
var useListClassrooms = (params, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getListClassroomsQueryKey(params);
  const queryFn = () => listClassrooms(params);
  const query = useQuery(queryKey, queryFn, queryOptions);
  return __spreadValues({
    queryKey
  }, query);
};
var createClassroom = (createClassroomRequestDto) => {
  return customInstance({
    url: `/classrooms`,
    method: "post",
    data: createClassroomRequestDto
  });
};
var useCreateClassroom = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { data } = props || {};
    return createClassroom(data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var getPerformance = (id) => {
  return customInstance({
    url: `/classrooms/${id}/performance`,
    method: "get"
  });
};
var getGetPerformanceQueryKey = (id) => [
  `/classrooms/${id}/performance`
];
var useGetPerformance = (id, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetPerformanceQueryKey(id);
  const queryFn = () => getPerformance(id);
  const query = useQuery(queryKey, queryFn, __spreadValues({ enabled: !!id }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var createOrAddStudentForClassroom = (id, createStudentForClassroomRequestDto) => {
  return customInstance({
    url: `/classrooms/${id}/students`,
    method: "post",
    data: createStudentForClassroomRequestDto
  });
};
var useCreateOrAddStudentForClassroom = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { id, data } = props || {};
    return createOrAddStudentForClassroom(id, data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var getStudentsForClassroom = (id) => {
  return customInstance({
    url: `/classrooms/${id}/students`,
    method: "get"
  });
};
var getGetStudentsForClassroomQueryKey = (id) => [
  `/classrooms/${id}/students`
];
var useGetStudentsForClassroom = (id, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetStudentsForClassroomQueryKey(id);
  const queryFn = () => getStudentsForClassroom(id);
  const query = useQuery(queryKey, queryFn, __spreadValues({ enabled: !!id }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var inviteStudentsToClassroom = (id, inviteStudentsRequestDto) => {
  return customInstance({
    url: `/classrooms/${id}/students/invite`,
    method: "post",
    data: inviteStudentsRequestDto
  });
};
var useInviteStudentsToClassroom = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { id, data } = props || {};
    return inviteStudentsToClassroom(id, data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var removeStudentFromClassroom = (id, studentId) => {
  return customInstance({
    url: `/classrooms/${id}/students/${studentId}`,
    method: "delete"
  });
};
var useRemoveStudentFromClassroom = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { id, studentId } = props || {};
    return removeStudentFromClassroom(id, studentId);
  };
  return useMutation(mutationFn, mutationOptions);
};
var getStudentPerformance = (classroomId, studentId) => {
  return customInstance({
    url: `/classrooms/${classroomId}/students/${studentId}/performance`,
    method: "get"
  });
};
var getGetStudentPerformanceQueryKey = (classroomId, studentId) => [`/classrooms/${classroomId}/students/${studentId}/performance`];
var useGetStudentPerformance = (classroomId, studentId, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetStudentPerformanceQueryKey(classroomId, studentId);
  const queryFn = () => getStudentPerformance(classroomId, studentId);
  const query = useQuery(queryKey, queryFn, __spreadValues({
    enabled: !!(classroomId && studentId)
  }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var getStudentSubmissions = (classroomId, studentId, params) => {
  return customInstance({
    url: `/classrooms/${classroomId}/students/${studentId}/submissions`,
    method: "get",
    params
  });
};
var getGetStudentSubmissionsQueryKey = (classroomId, studentId, params) => [
  `/classrooms/${classroomId}/students/${studentId}/submissions`,
  ...params ? [params] : []
];
var useGetStudentSubmissions = (classroomId, studentId, params, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetStudentSubmissionsQueryKey(classroomId, studentId, params);
  const queryFn = () => getStudentSubmissions(classroomId, studentId, params);
  const query = useQuery(queryKey, queryFn, __spreadValues({
    enabled: !!(classroomId && studentId)
  }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var createAssignmentForClassroom = (id, createAssignmentRequestDto) => {
  return customInstance({
    url: `/classrooms/${id}/assignments`,
    method: "post",
    data: createAssignmentRequestDto
  });
};
var useCreateAssignmentForClassroom = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { id, data } = props || {};
    return createAssignmentForClassroom(id, data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var getAssignmentsForClassroom = (id, params) => {
  return customInstance({
    url: `/classrooms/${id}/assignments`,
    method: "get",
    params
  });
};
var getGetAssignmentsForClassroomQueryKey = (id, params) => [`/classrooms/${id}/assignments`, ...params ? [params] : []];
var useGetAssignmentsForClassroom = (id, params, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetAssignmentsForClassroomQueryKey(id, params);
  const queryFn = () => getAssignmentsForClassroom(id, params);
  const query = useQuery(queryKey, queryFn, __spreadValues({ enabled: !!id }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var getSuggestionsForClassroom = (id, params) => {
  return customInstance({
    url: `/classrooms/${id}/suggestions`,
    method: "get",
    params
  });
};
var getGetSuggestionsForClassroomQueryKey = (id, params) => [`/classrooms/${id}/suggestions`, ...params ? [params] : []];
var useGetSuggestionsForClassroom = (id, params, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetSuggestionsForClassroomQueryKey(id, params);
  const queryFn = () => getSuggestionsForClassroom(id, params);
  const query = useQuery(queryKey, queryFn, __spreadValues({ enabled: !!id }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var getStandardPerformanceByGrade = (id, grade) => {
  return customInstance({
    url: `/classrooms/${id}/performance/standards/${grade}`,
    method: "get"
  });
};
var getGetStandardPerformanceByGradeQueryKey = (id, grade) => [`/classrooms/${id}/performance/standards/${grade}`];
var useGetStandardPerformanceByGrade = (id, grade, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetStandardPerformanceByGradeQueryKey(id, grade);
  const queryFn = () => getStandardPerformanceByGrade(id, grade);
  const query = useQuery(queryKey, queryFn, __spreadValues({ enabled: !!(id && grade) }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var createTag = (createTagRequestDto) => {
  return customInstance({
    url: `/backoffice/tags`,
    method: "post",
    data: createTagRequestDto
  });
};
var useCreateTag = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { data } = props || {};
    return createTag(data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var listTags = (params) => {
  return customInstance({
    url: `/backoffice/tags`,
    method: "get",
    params
  });
};
var getListTagsQueryKey = (params) => [
  `/backoffice/tags`,
  ...params ? [params] : []
];
var useListTags = (params, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getListTagsQueryKey(params);
  const queryFn = () => listTags(params);
  const query = useQuery(queryKey, queryFn, queryOptions);
  return __spreadValues({
    queryKey
  }, query);
};
var getTagById = (id) => {
  return customInstance({
    url: `/backoffice/tags/${id}`,
    method: "get"
  });
};
var getGetTagByIdQueryKey = (id) => [`/backoffice/tags/${id}`];
var useGetTagById = (id, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetTagByIdQueryKey(id);
  const queryFn = () => getTagById(id);
  const query = useQuery(queryKey, queryFn, __spreadValues({ enabled: !!id }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var updateTag = (id, updateTagRequestDto) => {
  return customInstance({
    url: `/backoffice/tags/${id}`,
    method: "put",
    data: updateTagRequestDto
  });
};
var useUpdateTag = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { id, data } = props || {};
    return updateTag(id, data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var deleteTag = (id) => {
  return customInstance({
    url: `/backoffice/tags/${id}`,
    method: "delete"
  });
};
var useDeleteTag = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { id } = props || {};
    return deleteTag(id);
  };
  return useMutation(mutationFn, mutationOptions);
};
var getSubmission = (id) => {
  return customInstance({
    url: `/submissions/${id}`,
    method: "get"
  });
};
var getGetSubmissionQueryKey = (id) => [`/submissions/${id}`];
var useGetSubmission = (id, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetSubmissionQueryKey(id);
  const queryFn = () => getSubmission(id);
  const query = useQuery(queryKey, queryFn, __spreadValues({ enabled: !!id }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var completeSubmission = (id) => {
  return customInstance({
    url: `/submissions/${id}/complete`,
    method: "post"
  });
};
var useCompleteSubmission = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { id } = props || {};
    return completeSubmission(id);
  };
  return useMutation(mutationFn, mutationOptions);
};
var getListOfItemsInSubmission = (id, params) => {
  return customInstance({
    url: `/submissions/${id}/items`,
    method: "get",
    params
  });
};
var getGetListOfItemsInSubmissionQueryKey = (id, params) => [`/submissions/${id}/items`, ...params ? [params] : []];
var useGetListOfItemsInSubmission = (id, params, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetListOfItemsInSubmissionQueryKey(id, params);
  const queryFn = () => getListOfItemsInSubmission(id, params);
  const query = useQuery(queryKey, queryFn, __spreadValues({ enabled: !!id }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var listInteractionsInSubmission = (id, params) => {
  return customInstance({
    url: `/submissions/${id}/interactions`,
    method: "get",
    params
  });
};
var getListInteractionsInSubmissionQueryKey = (id, params) => [`/submissions/${id}/interactions`, ...params ? [params] : []];
var useListInteractionsInSubmission = (id, params, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getListInteractionsInSubmissionQueryKey(id, params);
  const queryFn = () => listInteractionsInSubmission(id, params);
  const query = useQuery(queryKey, queryFn, __spreadValues({ enabled: !!id }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var getAssignment = (id) => {
  return customInstance({
    url: `/assignments/${id}`,
    method: "get"
  });
};
var getGetAssignmentQueryKey = (id) => [`/assignments/${id}`];
var useGetAssignment = (id, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetAssignmentQueryKey(id);
  const queryFn = () => getAssignment(id);
  const query = useQuery(queryKey, queryFn, __spreadValues({ enabled: !!id }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var updateAssignment = (id, updateAssignmentRequestDto) => {
  return customInstance({
    url: `/assignments/${id}`,
    method: "patch",
    data: updateAssignmentRequestDto
  });
};
var useUpdateAssignment = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { id, data } = props || {};
    return updateAssignment(id, data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var deleteAssignment = (id) => {
  return customInstance({
    url: `/assignments/${id}`,
    method: "delete"
  });
};
var useDeleteAssignment = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { id } = props || {};
    return deleteAssignment(id);
  };
  return useMutation(mutationFn, mutationOptions);
};
var getSubmissionsForAssignment = (id, params) => {
  return customInstance({
    url: `/assignments/${id}/submissions`,
    method: "get",
    params
  });
};
var getGetSubmissionsForAssignmentQueryKey = (id, params) => [`/assignments/${id}/submissions`, ...params ? [params] : []];
var useGetSubmissionsForAssignment = (id, params, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetSubmissionsForAssignmentQueryKey(id, params);
  const queryFn = () => getSubmissionsForAssignment(id, params);
  const query = useQuery(queryKey, queryFn, __spreadValues({ enabled: !!id }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var getStandardTreeByGrade = (grade) => {
  return customInstance({
    url: `/standards/${grade}`,
    method: "get"
  });
};
var getGetStandardTreeByGradeQueryKey = (grade) => [`/standards/${grade}`];
var useGetStandardTreeByGrade = (grade, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetStandardTreeByGradeQueryKey(grade);
  const queryFn = () => getStandardTreeByGrade(grade);
  const query = useQuery(queryKey, queryFn, __spreadValues({ enabled: !!grade }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var getStandardTree = (tagId) => {
  return customInstance({
    url: `/standards/tag/${tagId}`,
    method: "get"
  });
};
var getGetStandardTreeQueryKey = (tagId) => [
  `/standards/tag/${tagId}`
];
var useGetStandardTree = (tagId, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetStandardTreeQueryKey(tagId);
  const queryFn = () => getStandardTree(tagId);
  const query = useQuery(queryKey, queryFn, __spreadValues({ enabled: !!tagId }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var getItemInteraction = (interactionId) => {
  return customInstance({
    url: `/interactions/${interactionId}`,
    method: "get"
  });
};
var getGetItemInteractionQueryKey = (interactionId) => [
  `/interactions/${interactionId}`
];
var useGetItemInteraction = (interactionId, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetItemInteractionQueryKey(interactionId);
  const queryFn = () => getItemInteraction(interactionId);
  const query = useQuery(queryKey, queryFn, __spreadValues({ enabled: !!interactionId }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var updateInteraction = (interactionId, updateItemInteractionRequestDto) => {
  return customInstance({
    url: `/interactions/${interactionId}`,
    method: "patch",
    data: updateItemInteractionRequestDto
  });
};
var useUpdateInteraction = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { interactionId, data } = props || {};
    return updateInteraction(interactionId, data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var createItem = (createItemRequestDto) => {
  return customInstance({
    url: `/backoffice/items`,
    method: "post",
    data: createItemRequestDto
  });
};
var useCreateItem = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { data } = props || {};
    return createItem(data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var getItemById = (id) => {
  return customInstance({
    url: `/backoffice/items/${id}`,
    method: "get"
  });
};
var getGetItemByIdQueryKey = (id) => [
  `/backoffice/items/${id}`
];
var useGetItemById = (id, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getGetItemByIdQueryKey(id);
  const queryFn = () => getItemById(id);
  const query = useQuery(queryKey, queryFn, __spreadValues({ enabled: !!id }, queryOptions));
  return __spreadValues({
    queryKey
  }, query);
};
var updateItem = (id, updateItemRequestDto) => {
  return customInstance({
    url: `/backoffice/items/${id}`,
    method: "patch",
    data: updateItemRequestDto
  });
};
var useUpdateItem = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { id, data } = props || {};
    return updateItem(id, data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var deleteItem = (id) => {
  return customInstance({
    url: `/backoffice/items/${id}`,
    method: "delete"
  });
};
var useDeleteItem = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { id } = props || {};
    return deleteItem(id);
  };
  return useMutation(mutationFn, mutationOptions);
};
var listItemsByIds = (params) => {
  return customInstance({
    url: `/backoffice/items/directories/items`,
    method: "get",
    params
  });
};
var getListItemsByIdsQueryKey = (params) => [
  `/backoffice/items/directories/items`,
  ...params ? [params] : []
];
var useListItemsByIds = (params, options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getListItemsByIdsQueryKey(params);
  const queryFn = () => listItemsByIds(params);
  const query = useQuery(queryKey, queryFn, queryOptions);
  return __spreadValues({
    queryKey
  }, query);
};
var seedWithTsv = () => {
  return customInstance({
    url: `/backoffice/items/upload-tsv`,
    method: "post"
  });
};
var useSeedWithTsv = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = () => {
    return seedWithTsv();
  };
  return useMutation(mutationFn, mutationOptions);
};
var seedWithDefault = () => {
  return customInstance({
    url: `/backoffice/items/seed-default`,
    method: "post"
  });
};
var useSeedWithDefault = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = () => {
    return seedWithDefault();
  };
  return useMutation(mutationFn, mutationOptions);
};
var seedStandardRelationWithTsv = () => {
  return customInstance({
    url: `/backoffice/items/upload-tsv/standard-relation`,
    method: "post"
  });
};
var useSeedStandardRelationWithTsv = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = () => {
    return seedStandardRelationWithTsv();
  };
  return useMutation(mutationFn, mutationOptions);
};
var getInviteLinks = (qaGetStudentInviteLinkRequestDto) => {
  return customInstance({
    url: `/qa/getInvitationLink`,
    method: "post",
    data: qaGetStudentInviteLinkRequestDto
  });
};
var useGetInviteLinks = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { data } = props || {};
    return getInviteLinks(data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var getResetPasswordLink = (forgotPasswordRequestDto) => {
  return customInstance({
    url: `/qa/getResetPasswordLink`,
    method: "post",
    data: forgotPasswordRequestDto
  });
};
var useGetResetPasswordLink = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { data } = props || {};
    return getResetPasswordLink(data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var genData = (qaGenerateDataRequestDto) => {
  return customInstance({
    url: `/qa/data-gen`,
    method: "post",
    data: qaGenerateDataRequestDto
  });
};
var useGenData = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { data } = props || {};
    return genData(data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var healthOk = () => {
  return customInstance({
    url: `/actuator/health`,
    method: "get"
  });
};
var getHealthOkQueryKey = () => [`/actuator/health`];
var useHealthOk = (options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getHealthOkQueryKey();
  const queryFn = () => healthOk();
  const query = useQuery(queryKey, queryFn, queryOptions);
  return __spreadValues({
    queryKey
  }, query);
};
var statusOk = () => {
  return customInstance({ url: `/api/status`, method: "get" });
};
var getStatusOkQueryKey = () => [`/api/status`];
var useStatusOk = (options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getStatusOkQueryKey();
  const queryFn = () => statusOk();
  const query = useQuery(queryKey, queryFn, queryOptions);
  return __spreadValues({
    queryKey
  }, query);
};
var httpHealthCheck = () => {
  return customInstance({
    url: `/health/http`,
    method: "get"
  });
};
var getHttpHealthCheckQueryKey = () => [`/health/http`];
var useHttpHealthCheck = (options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getHttpHealthCheckQueryKey();
  const queryFn = () => httpHealthCheck();
  const query = useQuery(queryKey, queryFn, queryOptions);
  return __spreadValues({
    queryKey
  }, query);
};
var redisHealthCheck = () => {
  return customInstance({
    url: `/health/redis`,
    method: "get"
  });
};
var getRedisHealthCheckQueryKey = () => [`/health/redis`];
var useRedisHealthCheck = (options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getRedisHealthCheckQueryKey();
  const queryFn = () => redisHealthCheck();
  const query = useQuery(queryKey, queryFn, queryOptions);
  return __spreadValues({
    queryKey
  }, query);
};
var postgresHealthCheck = () => {
  return customInstance({
    url: `/health/postgres`,
    method: "get"
  });
};
var getPostgresHealthCheckQueryKey = () => [`/health/postgres`];
var usePostgresHealthCheck = (options) => {
  var _a;
  const { query: queryOptions } = options || {};
  const queryKey = (_a = queryOptions == null ? void 0 : queryOptions.queryKey) != null ? _a : getPostgresHealthCheckQueryKey();
  const queryFn = () => postgresHealthCheck();
  const query = useQuery(queryKey, queryFn, queryOptions);
  return __spreadValues({
    queryKey
  }, query);
};
var createDeveloper = (backofficeCreateDeveloperUserRequestDto) => {
  return customInstance({
    url: `/backoffice/developer`,
    method: "post",
    data: backofficeCreateDeveloperUserRequestDto
  });
};
var useCreateDeveloper = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { data } = props || {};
    return createDeveloper(data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var createTeacher = (createTeacherRequestDto) => {
  return customInstance({
    url: `/backoffice/teachers`,
    method: "post",
    data: createTeacherRequestDto
  });
};
var useCreateTeacher = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { data } = props || {};
    return createTeacher(data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var createClassroomForTeacher = (backofficeCreateClassroomRequestDto) => {
  return customInstance({
    url: `/backoffice/classrooms`,
    method: "post",
    data: backofficeCreateClassroomRequestDto
  });
};
var useCreateClassroomForTeacher = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { data } = props || {};
    return createClassroomForTeacher(data);
  };
  return useMutation(mutationFn, mutationOptions);
};
var createStudentsToClassroomWithCsv = (classroomId) => {
  return customInstance({
    url: `/backoffice/classrooms/${classroomId}/students/upload-csv`,
    method: "post"
  });
};
var useCreateStudentsToClassroomWithCsv = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { classroomId } = props || {};
    return createStudentsToClassroomWithCsv(classroomId);
  };
  return useMutation(mutationFn, mutationOptions);
};
var sso = (cleverOauthRequestDto) => {
  return customInstance({
    url: `/clever/oauth`,
    method: "post",
    data: cleverOauthRequestDto
  });
};
var useSso = (options) => {
  const { mutation: mutationOptions } = options || {};
  const mutationFn = (props) => {
    const { data } = props || {};
    return sso(data);
  };
  return useMutation(mutationFn, mutationOptions);
};

// src/generated/endpoints.msw.ts
import { rest } from "msw";
import faker from "@faker-js/faker";
var getSignUpMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  firstName: faker.random.word(),
  lastName: faker.random.word(),
  email: faker.random.word(),
  schoolName: faker.random.word(),
  sisId: faker.helpers.randomize([faker.random.word(), void 0]),
  type: faker.helpers.randomize(["teacher", "student", "developer"]),
  status: faker.helpers.randomize([
    "created",
    "pending",
    "active",
    "deactivated"
  ]),
  sso: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => faker.random.word())
});
var getFindSelfMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  firstName: faker.random.word(),
  lastName: faker.random.word(),
  email: faker.random.word(),
  schoolName: faker.random.word(),
  sisId: faker.helpers.randomize([faker.random.word(), void 0]),
  type: faker.helpers.randomize(["teacher", "student", "developer"]),
  status: faker.helpers.randomize([
    "created",
    "pending",
    "active",
    "deactivated"
  ]),
  sso: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => faker.random.word())
});
var getUpdateUserPasswordMock = () => ({
  message: faker.random.word()
});
var getFindUserMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  firstName: faker.random.word(),
  lastName: faker.random.word(),
  email: faker.random.word(),
  schoolName: faker.random.word(),
  sisId: faker.helpers.randomize([faker.random.word(), void 0]),
  type: faker.helpers.randomize(["teacher", "student", "developer"]),
  status: faker.helpers.randomize([
    "created",
    "pending",
    "active",
    "deactivated"
  ]),
  sso: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => faker.random.word())
});
var getUpdateUserMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  firstName: faker.random.word(),
  lastName: faker.random.word(),
  email: faker.random.word(),
  schoolName: faker.random.word(),
  sisId: faker.helpers.randomize([faker.random.word(), void 0]),
  type: faker.helpers.randomize(["teacher", "student", "developer"]),
  status: faker.helpers.randomize([
    "created",
    "pending",
    "active",
    "deactivated"
  ]),
  sso: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => faker.random.word())
});
var getAcceptInvitationMock = () => ({ message: faker.random.word() });
var getValidateInvitationTokenMock = () => ({
  firstName: faker.random.word(),
  lastName: faker.random.word(),
  email: faker.random.word()
});
var getLoginMock = () => ({
  accessToken: faker.random.word(),
  refreshToken: faker.random.word(),
  userId: faker.random.word(),
  userType: faker.random.word(),
  sso: faker.random.word()
});
var getRefreshTokenMock = () => ({
  userId: faker.random.word(),
  accessToken: faker.random.word(),
  refreshToken: faker.random.word()
});
var getResetPasswordMock = () => ({ message: faker.random.word() });
var getForgotPasswordMock = () => ({ message: faker.random.word() });
var getGetClassroomMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  grade: faker.helpers.randomize([
    faker.helpers.randomize([
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "pre_kindergarten",
      "transitional_kindergarten",
      "kindergarten",
      "infant_toddler",
      "preschool",
      "post_graduate",
      "ungraded",
      "other"
    ]),
    void 0
  ]),
  subject: faker.helpers.randomize([faker.random.word(), void 0]),
  classroomNumber: faker.helpers.randomize([faker.random.word(), void 0]),
  classroomName: faker.helpers.randomize([faker.random.word(), void 0]),
  timezone: faker.helpers.randomize([faker.random.word(), void 0]),
  primaryTeacherId: faker.random.word()
});
var getUpdateClassroomMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  grade: faker.helpers.randomize([
    faker.helpers.randomize([
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "pre_kindergarten",
      "transitional_kindergarten",
      "kindergarten",
      "infant_toddler",
      "preschool",
      "post_graduate",
      "ungraded",
      "other"
    ]),
    void 0
  ]),
  subject: faker.helpers.randomize([faker.random.word(), void 0]),
  classroomNumber: faker.helpers.randomize([faker.random.word(), void 0]),
  classroomName: faker.helpers.randomize([faker.random.word(), void 0]),
  timezone: faker.helpers.randomize([faker.random.word(), void 0])
});
var getDeactivateClassroomMock = () => ({
  message: faker.random.word()
});
var getListClassroomsMock = () => ({
  total: faker.datatype.number(),
  limit: faker.datatype.number(),
  offset: faker.datatype.number(),
  results: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => ({
    id: faker.random.word(),
    createdAt: faker.date.recent(2),
    updatedAt: faker.date.recent(2),
    grade: faker.helpers.randomize([
      faker.helpers.randomize([
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "pre_kindergarten",
        "transitional_kindergarten",
        "kindergarten",
        "infant_toddler",
        "preschool",
        "post_graduate",
        "ungraded",
        "other"
      ]),
      void 0
    ]),
    subject: faker.helpers.randomize([faker.random.word(), void 0]),
    classroomNumber: faker.helpers.randomize([faker.random.word(), void 0]),
    classroomName: faker.helpers.randomize([faker.random.word(), void 0]),
    timezone: faker.helpers.randomize([faker.random.word(), void 0]),
    primaryTeacherId: faker.random.word()
  }))
});
var getCreateClassroomMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  grade: faker.helpers.randomize([
    faker.helpers.randomize([
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "pre_kindergarten",
      "transitional_kindergarten",
      "kindergarten",
      "infant_toddler",
      "preschool",
      "post_graduate",
      "ungraded",
      "other"
    ]),
    void 0
  ]),
  subject: faker.helpers.randomize([faker.random.word(), void 0]),
  classroomNumber: faker.helpers.randomize([faker.random.word(), void 0]),
  classroomName: faker.helpers.randomize([faker.random.word(), void 0]),
  timezone: faker.helpers.randomize([faker.random.word(), void 0]),
  primaryTeacherId: faker.random.word()
});
var getGetPerformanceMock = () => ({
  performance: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => ({
    date: faker.date.recent(2),
    overallPerformance: faker.datatype.number()
  }))
});
var getCreateOrAddStudentForClassroomMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  firstName: faker.random.word(),
  lastName: faker.random.word(),
  email: faker.random.word(),
  schoolName: faker.random.word(),
  sisId: faker.helpers.randomize([faker.random.word(), void 0]),
  type: faker.helpers.randomize(["teacher", "student", "developer"]),
  status: faker.helpers.randomize([
    "created",
    "pending",
    "active",
    "deactivated"
  ]),
  sso: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => faker.random.word())
});
var getGetStudentsForClassroomMock = () => ({
  students: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => ({
    id: faker.random.word(),
    createdAt: faker.date.recent(2),
    updatedAt: faker.date.recent(2),
    firstName: faker.random.word(),
    lastName: faker.random.word(),
    email: faker.random.word(),
    schoolName: faker.random.word(),
    sisId: faker.helpers.randomize([faker.random.word(), void 0]),
    type: faker.helpers.randomize(["teacher", "student", "developer"]),
    status: faker.helpers.randomize([
      "created",
      "pending",
      "active",
      "deactivated"
    ]),
    sso: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => faker.random.word()),
    rank: faker.datatype.number(),
    grade: faker.datatype.number(),
    performanceTrend: faker.helpers.randomize([
      "not_enough_data",
      "trending_upwards",
      "trending_within_threshold",
      "trending_downwards"
    ])
  }))
});
var getInviteStudentsToClassroomMock = () => ({
  invitedStudentIds: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => faker.random.word())
});
var getRemoveStudentFromClassroomMock = () => ({
  message: faker.random.word()
});
var getCreateAssignmentForClassroomMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  name: faker.random.word(),
  subject: faker.helpers.randomize([faker.random.word(), void 0]),
  numberOfQuestions: faker.datatype.number(),
  dueDate: faker.random.word(),
  status: faker.helpers.randomize(["active", "grading_pending", "graded"]),
  createdById: faker.random.word(),
  classroomId: faker.random.word(),
  totalSubmissions: faker.datatype.number(),
  completedSubmissions: faker.datatype.number()
});
var getGetAssignmentsForClassroomMock = () => ({
  total: faker.datatype.number(),
  limit: faker.datatype.number(),
  offset: faker.datatype.number(),
  results: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => ({
    id: faker.random.word(),
    createdAt: faker.date.recent(2),
    updatedAt: faker.date.recent(2),
    name: faker.random.word(),
    subject: faker.helpers.randomize([faker.random.word(), void 0]),
    numberOfQuestions: faker.datatype.number(),
    dueDate: faker.random.word(),
    status: faker.helpers.randomize(["active", "grading_pending", "graded"]),
    createdById: faker.random.word(),
    classroomId: faker.random.word(),
    totalSubmissions: faker.datatype.number(),
    completedSubmissions: faker.datatype.number()
  }))
});
var getGetSuggestionsForClassroomMock = () => ({
  total: faker.datatype.number(),
  limit: faker.datatype.number(),
  offset: faker.datatype.number(),
  results: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => ({
    id: faker.random.word(),
    createdAt: faker.date.recent(2),
    updatedAt: faker.date.recent(2),
    category: faker.helpers.randomize([
      "default",
      "late_submission",
      "low_performance"
    ]),
    message: faker.random.word(),
    studentId: faker.random.word()
  }))
});
var getGetMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  status: faker.helpers.randomize(["active", "completed"]),
  completedAt: faker.helpers.randomize([faker.random.word(), void 0]),
  grade: faker.datatype.number(),
  overallGrade: faker.datatype.number(),
  trend: faker.helpers.randomize([
    "not_enough_data",
    "trending_upwards",
    "trending_within_threshold",
    "trending_downwards"
  ]),
  assignmentId: faker.random.word(),
  studentId: faker.random.word(),
  classroomId: faker.random.word(),
  answeredInteractions: faker.helpers.randomize([
    faker.datatype.number(),
    void 0
  ]),
  totalInteractions: faker.helpers.randomize([
    faker.datatype.number(),
    void 0
  ]),
  name: faker.random.word(),
  subject: faker.helpers.randomize([faker.random.word(), void 0]),
  numberOfQuestions: faker.datatype.number(),
  dueDate: faker.random.word()
});
var getCompleteSubmissionMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  status: faker.helpers.randomize(["active", "completed"]),
  completedAt: faker.helpers.randomize([faker.random.word(), void 0]),
  grade: faker.datatype.number(),
  overallGrade: faker.datatype.number(),
  trend: faker.helpers.randomize([
    "not_enough_data",
    "trending_upwards",
    "trending_within_threshold",
    "trending_downwards"
  ]),
  assignmentId: faker.random.word(),
  studentId: faker.random.word(),
  classroomId: faker.random.word(),
  answeredInteractions: faker.helpers.randomize([
    faker.datatype.number(),
    void 0
  ]),
  totalInteractions: faker.helpers.randomize([
    faker.datatype.number(),
    void 0
  ])
});
var getGetListOfItemsInSubmissionMock = () => ({
  total: faker.datatype.number(),
  limit: faker.datatype.number(),
  offset: faker.datatype.number(),
  results: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => ({
    id: faker.random.word(),
    createdAt: faker.date.recent(2),
    updatedAt: faker.date.recent(2),
    description: faker.random.word(),
    tagIds: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => faker.random.word()),
    status: faker.helpers.randomize([
      "unspecified",
      "published",
      "editing",
      "deleted"
    ]),
    maxScore: faker.datatype.number(),
    downloadUrl: faker.random.word()
  }))
});
var getListInteractionsInSubmissionMock = () => ({
  total: faker.datatype.number(),
  limit: faker.datatype.number(),
  offset: faker.datatype.number(),
  results: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => ({
    id: faker.random.word(),
    createdAt: faker.date.recent(2),
    updatedAt: faker.date.recent(2),
    startedAt: faker.date.recent(2),
    completedAt: faker.date.recent(2),
    userAnswer: faker.random.word(),
    itemId: faker.random.word(),
    elapsedTimeMs: faker.datatype.number(),
    score: faker.datatype.number(),
    maxScore: faker.datatype.number(),
    downloadUrl: faker.random.word()
  }))
});
var getGetAssignmentMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  name: faker.random.word(),
  subject: faker.helpers.randomize([faker.random.word(), void 0]),
  numberOfQuestions: faker.datatype.number(),
  dueDate: faker.random.word(),
  status: faker.helpers.randomize(["active", "grading_pending", "graded"]),
  createdById: faker.random.word(),
  classroomId: faker.random.word(),
  totalSubmissions: faker.datatype.number(),
  completedSubmissions: faker.datatype.number()
});
var getUpdateAssignmentMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  name: faker.random.word(),
  subject: faker.helpers.randomize([faker.random.word(), void 0]),
  numberOfQuestions: faker.datatype.number(),
  dueDate: faker.random.word(),
  status: faker.helpers.randomize(["active", "grading_pending", "graded"]),
  createdById: faker.random.word(),
  classroomId: faker.random.word()
});
var getDeleteAssignmentMock = () => ({ message: faker.random.word() });
var getGetSubmissionsForAssignmentMock = () => ({
  total: faker.datatype.number(),
  limit: faker.datatype.number(),
  offset: faker.datatype.number(),
  results: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => ({
    id: faker.random.word(),
    createdAt: faker.date.recent(2),
    updatedAt: faker.date.recent(2),
    status: faker.helpers.randomize(["active", "completed"]),
    completedAt: faker.helpers.randomize([faker.random.word(), void 0]),
    grade: faker.datatype.number(),
    overallGrade: faker.datatype.number(),
    trend: faker.helpers.randomize([
      "not_enough_data",
      "trending_upwards",
      "trending_within_threshold",
      "trending_downwards"
    ]),
    assignmentId: faker.random.word(),
    studentId: faker.random.word(),
    classroomId: faker.random.word(),
    answeredInteractions: faker.helpers.randomize([
      faker.datatype.number(),
      void 0
    ]),
    totalInteractions: faker.helpers.randomize([
      faker.datatype.number(),
      void 0
    ]),
    name: faker.random.word(),
    subject: faker.helpers.randomize([faker.random.word(), void 0]),
    numberOfQuestions: faker.datatype.number(),
    dueDate: faker.random.word()
  }))
});
var getGetStandardTreeByGradeMock = () => ({
  cl15pb69s0000kllz7ganfvhn: {
    id: faker.random.word(),
    parent: faker.random.word(),
    description: faker.random.word(),
    numberOfQuestions: faker.datatype.number(),
    children: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => faker.random.word())
  }
});
var getGetStandardTreeMock = () => ({
  cl15pb69t0001kllzb2xq57uu: {
    id: faker.random.word(),
    parent: faker.random.word(),
    description: faker.random.word(),
    numberOfQuestions: faker.datatype.number(),
    children: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => faker.random.word())
  }
});
var getGetItemInteractionMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  startedAt: faker.date.recent(2),
  completedAt: faker.date.recent(2),
  userAnswer: faker.random.word(),
  itemId: faker.random.word(),
  elapsedTimeMs: faker.datatype.number(),
  score: faker.datatype.number(),
  maxScore: faker.datatype.number(),
  downloadUrl: faker.random.word()
});
var getUpdateInteractionMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  startedAt: faker.date.recent(2),
  completedAt: faker.date.recent(2),
  userAnswer: faker.random.word(),
  itemId: faker.random.word(),
  elapsedTimeMs: faker.datatype.number(),
  score: faker.datatype.number(),
  maxScore: faker.datatype.number(),
  downloadUrl: faker.random.word()
});
var getCreateItemMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  description: faker.random.word(),
  tagIds: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => faker.random.word()),
  status: faker.helpers.randomize([
    "unspecified",
    "published",
    "editing",
    "deleted"
  ]),
  maxScore: faker.datatype.number(),
  downloadUrl: faker.random.word()
});
var getGetItemByIdMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  description: faker.random.word(),
  tagIds: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => faker.random.word()),
  status: faker.helpers.randomize([
    "unspecified",
    "published",
    "editing",
    "deleted"
  ]),
  maxScore: faker.datatype.number(),
  downloadUrl: faker.random.word()
});
var getUpdateItemMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  description: faker.random.word(),
  tagIds: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => faker.random.word()),
  status: faker.helpers.randomize([
    "unspecified",
    "published",
    "editing",
    "deleted"
  ]),
  maxScore: faker.datatype.number(),
  downloadUrl: faker.random.word()
});
var getDeleteItemMock = () => ({ message: faker.random.word() });
var getListItemsByIdsMock = () => ({
  items: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => ({
    id: faker.random.word(),
    createdAt: faker.date.recent(2),
    updatedAt: faker.date.recent(2),
    description: faker.random.word(),
    tagIds: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => faker.random.word()),
    status: faker.helpers.randomize([
      "unspecified",
      "published",
      "editing",
      "deleted"
    ]),
    maxScore: faker.datatype.number(),
    downloadUrl: faker.random.word()
  }))
});
var getSeedWithTsvMock = () => ({
  item: faker.datatype.number(),
  tag: faker.datatype.number(),
  relation: faker.datatype.number()
});
var getSeedWithDefaultMock = () => ({
  item: faker.datatype.number(),
  tag: faker.datatype.number(),
  relation: faker.datatype.number()
});
var getSeedStandardRelationWithTsvMock = () => ({
  standardRelation: faker.datatype.number()
});
var getCreateTagMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  type: faker.helpers.randomize(["unspecified", "item"]),
  description: faker.random.word(),
  tagKey: faker.random.word(),
  tagValue: faker.random.word()
});
var getListTagsMock = () => ({
  total: faker.datatype.number(),
  limit: faker.datatype.number(),
  offset: faker.datatype.number(),
  results: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => ({
    id: faker.random.word(),
    createdAt: faker.date.recent(2),
    updatedAt: faker.date.recent(2),
    type: faker.helpers.randomize(["unspecified", "item"]),
    description: faker.random.word(),
    tagKey: faker.random.word(),
    tagValue: faker.random.word()
  }))
});
var getGetTagByIdMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  type: faker.helpers.randomize(["unspecified", "item"]),
  description: faker.random.word(),
  tagKey: faker.random.word(),
  tagValue: faker.random.word()
});
var getUpdateTagMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  type: faker.helpers.randomize(["unspecified", "item"]),
  description: faker.random.word(),
  tagKey: faker.random.word(),
  tagValue: faker.random.word()
});
var getDeleteTagMock = () => ({ message: faker.random.word() });
var getGetInviteLinksMock = () => ({
  link: faker.random.word(),
  user: {
    id: faker.random.word(),
    createdAt: faker.date.recent(2),
    updatedAt: faker.date.recent(2),
    firstName: faker.random.word(),
    lastName: faker.random.word(),
    email: faker.random.word(),
    schoolName: faker.random.word(),
    sisId: faker.helpers.randomize([faker.random.word(), void 0]),
    type: faker.helpers.randomize(["teacher", "student", "developer"]),
    status: faker.helpers.randomize([
      "created",
      "pending",
      "active",
      "deactivated"
    ]),
    sso: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => faker.random.word())
  }
});
var getGetResetPasswordLinkMock = () => ({
  link: faker.random.word()
});
var getHealthOkMock = () => ({ message: faker.random.word() });
var getStatusOkMock = () => ({ message: faker.random.word() });
var getHttpHealthCheckMock = () => ({
  status: faker.helpers.randomize([faker.random.word(), void 0]),
  info: faker.helpers.randomize([
    {
      cl15pb6a70002kllzhxvueou1: {
        status: faker.helpers.randomize([faker.random.word(), void 0])
      }
    },
    void 0
  ]),
  error: faker.helpers.randomize([
    {
      cl15pb6a70003kllz96o4hq4w: {
        status: faker.helpers.randomize([faker.random.word(), void 0])
      }
    },
    void 0
  ]),
  details: faker.helpers.randomize([
    {
      cl15pb6a70004kllza4360zg4: {
        status: faker.helpers.randomize([faker.random.word(), void 0])
      }
    },
    void 0
  ])
});
var getRedisHealthCheckMock = () => ({
  status: faker.helpers.randomize([faker.random.word(), void 0]),
  info: faker.helpers.randomize([
    {
      cl15pb6a80005kllz6v4o7mui: {
        status: faker.helpers.randomize([faker.random.word(), void 0])
      }
    },
    void 0
  ]),
  error: faker.helpers.randomize([
    {
      cl15pb6a80006kllzaoe6g7vj: {
        status: faker.helpers.randomize([faker.random.word(), void 0])
      }
    },
    void 0
  ]),
  details: faker.helpers.randomize([
    {
      cl15pb6a80007kllz7l32ahry: {
        status: faker.helpers.randomize([faker.random.word(), void 0])
      }
    },
    void 0
  ])
});
var getPostgresHealthCheckMock = () => ({
  status: faker.helpers.randomize([faker.random.word(), void 0]),
  info: faker.helpers.randomize([
    {
      cl15pb6a90008kllz0igu2m4z: {
        status: faker.helpers.randomize([faker.random.word(), void 0])
      }
    },
    void 0
  ]),
  error: faker.helpers.randomize([
    {
      cl15pb6a90009kllz3olq3uc4: {
        status: faker.helpers.randomize([faker.random.word(), void 0])
      }
    },
    void 0
  ]),
  details: faker.helpers.randomize([
    {
      cl15pb6a9000akllzf11z086d: {
        status: faker.helpers.randomize([faker.random.word(), void 0])
      }
    },
    void 0
  ])
});
var getCreateDeveloperMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  firstName: faker.random.word(),
  lastName: faker.random.word(),
  email: faker.random.word(),
  schoolName: faker.random.word(),
  sisId: faker.helpers.randomize([faker.random.word(), void 0]),
  type: faker.helpers.randomize(["teacher", "student", "developer"]),
  status: faker.helpers.randomize([
    "created",
    "pending",
    "active",
    "deactivated"
  ]),
  sso: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => faker.random.word())
});
var getCreateTeacherMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  firstName: faker.random.word(),
  lastName: faker.random.word(),
  email: faker.random.word(),
  schoolName: faker.random.word(),
  sisId: faker.helpers.randomize([faker.random.word(), void 0]),
  type: faker.helpers.randomize(["teacher", "student", "developer"]),
  status: faker.helpers.randomize([
    "created",
    "pending",
    "active",
    "deactivated"
  ]),
  sso: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => faker.random.word())
});
var getCreateClassroomForTeacherMock = () => ({
  id: faker.random.word(),
  createdAt: faker.date.recent(2),
  updatedAt: faker.date.recent(2),
  grade: faker.helpers.randomize([
    faker.helpers.randomize([
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "pre_kindergarten",
      "transitional_kindergarten",
      "kindergarten",
      "infant_toddler",
      "preschool",
      "post_graduate",
      "ungraded",
      "other"
    ]),
    void 0
  ]),
  subject: faker.helpers.randomize([faker.random.word(), void 0]),
  classroomNumber: faker.helpers.randomize([faker.random.word(), void 0]),
  classroomName: faker.helpers.randomize([faker.random.word(), void 0]),
  timezone: faker.helpers.randomize([faker.random.word(), void 0]),
  primaryTeacherId: faker.random.word()
});
var getCreateStudentsToClassroomWithCsvMock = () => ({
  students: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => ({
    id: faker.random.word(),
    createdAt: faker.date.recent(2),
    updatedAt: faker.date.recent(2),
    firstName: faker.random.word(),
    lastName: faker.random.word(),
    email: faker.random.word(),
    schoolName: faker.random.word(),
    sisId: faker.helpers.randomize([faker.random.word(), void 0]),
    type: faker.helpers.randomize(["teacher", "student", "developer"]),
    status: faker.helpers.randomize([
      "created",
      "pending",
      "active",
      "deactivated"
    ]),
    sso: [...Array(faker.datatype.number({ min: 1, max: 10 }))].map(() => faker.random.word())
  }))
});
var getSsoMock = () => ({
  accessToken: faker.random.word(),
  refreshToken: faker.random.word(),
  userId: faker.random.word(),
  userType: faker.random.word(),
  sso: faker.random.word()
});
var getJarvisAPIMSW = () => [
  rest.post("*/users", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getSignUpMock()));
  }),
  rest.get("*/users/me", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getFindSelfMock()));
  }),
  rest.put("*/users/me/password", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getUpdateUserPasswordMock()));
  }),
  rest.get("*/users/:id", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getFindUserMock()));
  }),
  rest.patch("*/users/:id", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getUpdateUserMock()));
  }),
  rest.post("*/users/invitation/accept", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getAcceptInvitationMock()));
  }),
  rest.post("*/users/invitation/validate", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getValidateInvitationTokenMock()));
  }),
  rest.post("*/auth/login", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getLoginMock()));
  }),
  rest.post("*/auth/refresh-token", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getRefreshTokenMock()));
  }),
  rest.post("*/auth/password/reset", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getResetPasswordMock()));
  }),
  rest.post("*/auth/password/forgot", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getForgotPasswordMock()));
  }),
  rest.get("*/classrooms/:id", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getGetClassroomMock()));
  }),
  rest.patch("*/classrooms/:id", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getUpdateClassroomMock()));
  }),
  rest.delete("*/classrooms/:id", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getDeactivateClassroomMock()));
  }),
  rest.get("*/classrooms", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getListClassroomsMock()));
  }),
  rest.post("*/classrooms", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getCreateClassroomMock()));
  }),
  rest.get("*/classrooms/:id/performance", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getGetPerformanceMock()));
  }),
  rest.post("*/classrooms/:id/students", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getCreateOrAddStudentForClassroomMock()));
  }),
  rest.get("*/classrooms/:id/students", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getGetStudentsForClassroomMock()));
  }),
  rest.post("*/classrooms/:id/students/invite", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getInviteStudentsToClassroomMock()));
  }),
  rest.delete("*/classrooms/:id/students/:studentId", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getRemoveStudentFromClassroomMock()));
  }),
  rest.get("*/classrooms/:classroomId/students/:studentId/performance", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"));
  }),
  rest.get("*/classrooms/:classroomId/students/:studentId/submissions", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"));
  }),
  rest.post("*/classrooms/:id/assignments", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getCreateAssignmentForClassroomMock()));
  }),
  rest.get("*/classrooms/:id/assignments", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getGetAssignmentsForClassroomMock()));
  }),
  rest.get("*/classrooms/:id/suggestions", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getGetSuggestionsForClassroomMock()));
  }),
  rest.get("*/submissions/:id", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getGetMock()));
  }),
  rest.post("*/submissions/:id/complete", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getCompleteSubmissionMock()));
  }),
  rest.get("*/submissions/:id/items", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getGetListOfItemsInSubmissionMock()));
  }),
  rest.get("*/submissions/:id/interactions", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getListInteractionsInSubmissionMock()));
  }),
  rest.get("*/assignments/:id", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getGetAssignmentMock()));
  }),
  rest.patch("*/assignments/:id", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getUpdateAssignmentMock()));
  }),
  rest.delete("*/assignments/:id", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getDeleteAssignmentMock()));
  }),
  rest.get("*/assignments/:id/submissions", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getGetSubmissionsForAssignmentMock()));
  }),
  rest.get("*/standards/:grade", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getGetStandardTreeByGradeMock()));
  }),
  rest.get("*/standards/tag/:tagId", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getGetStandardTreeMock()));
  }),
  rest.get("*/interactions/:interactionId", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getGetItemInteractionMock()));
  }),
  rest.patch("*/interactions/:interactionId", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getUpdateInteractionMock()));
  }),
  rest.post("*/backoffice/items", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getCreateItemMock()));
  }),
  rest.get("*/backoffice/items/:id", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getGetItemByIdMock()));
  }),
  rest.patch("*/backoffice/items/:id", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getUpdateItemMock()));
  }),
  rest.delete("*/backoffice/items/:id", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getDeleteItemMock()));
  }),
  rest.get("*/backoffice/items/directories/items", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getListItemsByIdsMock()));
  }),
  rest.post("*/backoffice/items/upload-tsv", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getSeedWithTsvMock()));
  }),
  rest.post("*/backoffice/items/seed-default", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getSeedWithDefaultMock()));
  }),
  rest.post("*/backoffice/items/upload-tsv/standard-relation", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getSeedStandardRelationWithTsvMock()));
  }),
  rest.post("*/backoffice/tags", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getCreateTagMock()));
  }),
  rest.get("*/backoffice/tags", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getListTagsMock()));
  }),
  rest.get("*/backoffice/tags/:id", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getGetTagByIdMock()));
  }),
  rest.put("*/backoffice/tags/:id", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getUpdateTagMock()));
  }),
  rest.delete("*/backoffice/tags/:id", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getDeleteTagMock()));
  }),
  rest.post("*/qa/getInvitationLink", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getGetInviteLinksMock()));
  }),
  rest.post("*/qa/getResetPasswordLink", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getGetResetPasswordLinkMock()));
  }),
  rest.get("*/actuator/health", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getHealthOkMock()));
  }),
  rest.get("*/api/status", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getStatusOkMock()));
  }),
  rest.get("*/health/http", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getHttpHealthCheckMock()));
  }),
  rest.get("*/health/redis", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getRedisHealthCheckMock()));
  }),
  rest.get("*/health/postgres", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getPostgresHealthCheckMock()));
  }),
  rest.post("*/backoffice/developer", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getCreateDeveloperMock()));
  }),
  rest.post("*/backoffice/teachers", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getCreateTeacherMock()));
  }),
  rest.post("*/backoffice/classrooms", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getCreateClassroomForTeacherMock()));
  }),
  rest.post("*/backoffice/classrooms/:classroomId/students/upload-csv", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getCreateStudentsToClassroomWithCsvMock()));
  }),
  rest.post("*/clever/oauth", (_req, res, ctx) => {
    return res(ctx.delay(1e3), ctx.status(200, "Mocked status"), ctx.json(getSsoMock()));
  })
];
export {
  AssignmentResponseDtoStatus,
  BackofficeCreateClassroomRequestDtoGrade,
  CUSTOM_FETCHER,
  ClassroomResponseDtoGrade,
  ClassroomStudentPerformanceResponseDtoPerformance,
  CompleteSubmissionResponseDtoStatus,
  CompleteSubmissionResponseDtoTrend,
  CreateAssignmentRequestDtoGrade,
  CreateAssignmentResponseDtoStatus,
  CreateClassroomRequestDtoGrade,
  CreateClassroomResponseDtoGrade,
  CreateItemRequestDtoStatus,
  CreateStudentForClassroomResponseDtoStatus,
  CreateStudentForClassroomResponseDtoType,
  CreateTagRequestDtoType,
  CreateUserResponseDtoStatus,
  CreateUserResponseDtoType,
  ItemResponseDtoStatus,
  StudentPerformanceDtoPerformanceOneOfStatus,
  StudentPerformanceDtoPerformanceOneOfThreeStatus,
  StudentWithGradeDtoPerformanceTrend,
  StudentWithGradeDtoStatus,
  StudentWithGradeDtoType,
  SubmissionResponseDtoStatus,
  SubmissionResponseDtoTrend,
  SuggestionResponseDtoCategory,
  TagResponseDtoType,
  UpdateAssignmentResponseDtoStatus,
  UpdateClassroomRequestDtoGrade,
  UpdateClassroomResponseDtoGrade,
  UpdateItemRequestDtoStatus,
  UpdateUserResponseDtoStatus,
  UpdateUserResponseDtoType,
  UserResponseDtoStatus,
  UserResponseDtoType,
  acceptInvitation,
  acceptVerificationToken,
  completeSubmission,
  createAssignmentForClassroom,
  createClassroom,
  createClassroomForTeacher,
  createDeveloper,
  createItem,
  createOrAddStudentForClassroom,
  createStudentsToClassroomWithCsv,
  createTag,
  createTeacher,
  customInstance,
  deactivateClassroom,
  deleteAssignment,
  deleteItem,
  deleteTag,
  findSelf,
  findUser,
  forgotPassword,
  genData,
  getAcceptInvitationMock,
  getAssignment,
  getAssignmentsForClassroom,
  getClassroom,
  getCompleteSubmissionMock,
  getCreateAssignmentForClassroomMock,
  getCreateClassroomForTeacherMock,
  getCreateClassroomMock,
  getCreateDeveloperMock,
  getCreateItemMock,
  getCreateOrAddStudentForClassroomMock,
  getCreateStudentsToClassroomWithCsvMock,
  getCreateTagMock,
  getCreateTeacherMock,
  getDeactivateClassroomMock,
  getDeleteAssignmentMock,
  getDeleteItemMock,
  getDeleteTagMock,
  getFindSelfMock,
  getFindSelfQueryKey,
  getFindUserMock,
  getFindUserQueryKey,
  getForgotPasswordMock,
  getGetAssignmentMock,
  getGetAssignmentQueryKey,
  getGetAssignmentsForClassroomMock,
  getGetAssignmentsForClassroomQueryKey,
  getGetClassroomMock,
  getGetClassroomQueryKey,
  getGetInviteLinksMock,
  getGetItemByIdMock,
  getGetItemByIdQueryKey,
  getGetItemInteractionMock,
  getGetItemInteractionQueryKey,
  getGetListOfItemsInSubmissionMock,
  getGetListOfItemsInSubmissionQueryKey,
  getGetMock,
  getGetPerformanceMock,
  getGetPerformanceQueryKey,
  getGetResetPasswordLinkMock,
  getGetStandardPerformanceByGradeQueryKey,
  getGetStandardTreeByGradeMock,
  getGetStandardTreeByGradeQueryKey,
  getGetStandardTreeMock,
  getGetStandardTreeQueryKey,
  getGetStudentPerformanceQueryKey,
  getGetStudentSubmissionsQueryKey,
  getGetStudentsForClassroomMock,
  getGetStudentsForClassroomQueryKey,
  getGetSubmissionQueryKey,
  getGetSubmissionsForAssignmentMock,
  getGetSubmissionsForAssignmentQueryKey,
  getGetSuggestionsForClassroomMock,
  getGetSuggestionsForClassroomQueryKey,
  getGetTagByIdMock,
  getGetTagByIdQueryKey,
  getHealthOkMock,
  getHealthOkQueryKey,
  getHttpHealthCheckMock,
  getHttpHealthCheckQueryKey,
  getInviteLinks,
  getInviteStudentsToClassroomMock,
  getItemById,
  getItemInteraction,
  getJarvisAPIMSW,
  getListClassroomsMock,
  getListClassroomsQueryKey,
  getListInteractionsInSubmissionMock,
  getListInteractionsInSubmissionQueryKey,
  getListItemsByIdsMock,
  getListItemsByIdsQueryKey,
  getListOfItemsInSubmission,
  getListTagsMock,
  getListTagsQueryKey,
  getLoginMock,
  getPerformance,
  getPostgresHealthCheckMock,
  getPostgresHealthCheckQueryKey,
  getRedisHealthCheckMock,
  getRedisHealthCheckQueryKey,
  getRefreshTokenMock,
  getRemoveStudentFromClassroomMock,
  getResetPasswordLink,
  getResetPasswordMock,
  getSeedStandardRelationWithTsvMock,
  getSeedWithDefaultMock,
  getSeedWithTsvMock,
  getSignUpMock,
  getSsoMock,
  getStandardPerformanceByGrade,
  getStandardTree,
  getStandardTreeByGrade,
  getStatusOkMock,
  getStatusOkQueryKey,
  getStudentPerformance,
  getStudentSubmissions,
  getStudentsForClassroom,
  getSubmission,
  getSubmissionsForAssignment,
  getSuggestionsForClassroom,
  getTagById,
  getUpdateAssignmentMock,
  getUpdateClassroomMock,
  getUpdateInteractionMock,
  getUpdateItemMock,
  getUpdateTagMock,
  getUpdateUserMock,
  getUpdateUserPasswordMock,
  getValidateInvitationTokenMock,
  healthOk,
  httpHealthCheck,
  inviteStudentsToClassroom,
  listClassrooms,
  listInteractionsInSubmission,
  listItemsByIds,
  listTags,
  login,
  postgresHealthCheck,
  redisHealthCheck,
  refreshToken,
  removeStudentFromClassroom,
  resetPassword,
  seedStandardRelationWithTsv,
  seedWithDefault,
  seedWithTsv,
  sendVerificationEmail,
  signUp,
  sso,
  statusOk,
  updateAssignment,
  updateClassroom,
  updateInteraction,
  updateItem,
  updateTag,
  updateUser,
  updateUserPassword,
  useAcceptInvitation,
  useAcceptVerificationToken,
  useCompleteSubmission,
  useCreateAssignmentForClassroom,
  useCreateClassroom,
  useCreateClassroomForTeacher,
  useCreateDeveloper,
  useCreateItem,
  useCreateOrAddStudentForClassroom,
  useCreateStudentsToClassroomWithCsv,
  useCreateTag,
  useCreateTeacher,
  useDeactivateClassroom,
  useDeleteAssignment,
  useDeleteItem,
  useDeleteTag,
  useFindSelf,
  useFindUser,
  useForgotPassword,
  useGenData,
  useGetAssignment,
  useGetAssignmentsForClassroom,
  useGetClassroom,
  useGetInviteLinks,
  useGetItemById,
  useGetItemInteraction,
  useGetListOfItemsInSubmission,
  useGetPerformance,
  useGetResetPasswordLink,
  useGetStandardPerformanceByGrade,
  useGetStandardTree,
  useGetStandardTreeByGrade,
  useGetStudentPerformance,
  useGetStudentSubmissions,
  useGetStudentsForClassroom,
  useGetSubmission,
  useGetSubmissionsForAssignment,
  useGetSuggestionsForClassroom,
  useGetTagById,
  useHealthOk,
  useHttpHealthCheck,
  useInviteStudentsToClassroom,
  useListClassrooms,
  useListInteractionsInSubmission,
  useListItemsByIds,
  useListTags,
  useLogin,
  usePostgresHealthCheck,
  useRedisHealthCheck,
  useRefreshToken,
  useRemoveStudentFromClassroom,
  useResetPassword,
  useSeedStandardRelationWithTsv,
  useSeedWithDefault,
  useSeedWithTsv,
  useSendVerificationEmail,
  useSignUp,
  useSso,
  useStatusOk,
  useUpdateAssignment,
  useUpdateClassroom,
  useUpdateInteraction,
  useUpdateItem,
  useUpdateTag,
  useUpdateUser,
  useUpdateUserPassword,
  useValidateInvitationToken,
  validateInvitationToken
};
//# sourceMappingURL=index.js.map